import GeneralSettingView from './generalSettings';
import FortyThreeISetting from './43i';
import SixtyISettings from './60i';
import AutoZeroSettings from './autoZeroSettings';
import ResponseTimeSettings from './responseTimeSettings';
import GasCylinderSettings from './gasCylindersSettings';
import StabilitySettings from './stabilitySettings';
import SO2ScrubberSettings from './sO2Scrubber';
import PIDControllersSettings from './pidControllersSettings';
import QAL3Settings from './qal3Settings';

export {
  GeneralSettingView,
  FortyThreeISetting,
  SixtyISettings,
  AutoZeroSettings,
  ResponseTimeSettings,
  GasCylinderSettings,
  StabilitySettings,
  SO2ScrubberSettings,
  PIDControllersSettings,
  QAL3Settings,
};

export default {};
